// @flow
import React from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';
import { truncate } from 'Components/utils/string/string.util';

import { Badge } from 'Components/frameworks/badge/Badge.jsx';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

import { themes } from './PostQuestion.themes';

export type PostQuestionProps = {
  answersCount?: number,
  author?: {
    color?: Colors,
    avatarImg?: string,
    name: string,
  },
  className?: string,
  date?: string,
  id?: string,
  likesCount?: number,
  seeMoreLabel?: string,
  text?: string,
  textLimit?: number,
  theme?: string,
  title: string,
  titleId?: string,
  titleLimit?: number,
};

export function PostQuestion(props: PostQuestionProps) {
  const {
    answersCount = 0,
    author = {},
    className,
    date,
    id,
    likesCount = 0,
    seeMoreLabel,
    text,
    textLimit = 130,
    theme = 'default',
    title,
    titleId,
    titleLimit = -1,
  } = props;

  if (!title) return null;

  const {
    thAnswers,
    thAuthor,
    thBadge,
    thBadgeIconSize,
    thBadgeSize,
    thBadgeVariant,
    thBottom,
    thDate,
    thIcon,
    thIconSize,
    thLikes,
    thRoot,
    thSeeMore,
    thText,
    thTitle,
    thTitleTheme,
    thTop,
  } = themes[theme](props);

  return (
    <article id={id} className={classnames(thRoot, className)}>
      <div className={thTop}>
        <Badge
          alt={author.avatarImg && author.name}
          className={thBadge}
          colorBg={author.color}
          colorBorder={author.color}
          iconSize={thBadgeIconSize}
          size={thBadgeSize}
          variant={thBadgeVariant}
          {...(author.avatarImg ? { imageSrc: author.avatarImg } : { iconName: ICONS.USER })}
        />
        {!!author.name && <span className={thAuthor}>{author.name}</span>}
        {!!date && <span className={thDate}>{date}</span>}
      </div>
      <Title id={titleId} className={thTitle} theme={thTitleTheme}>
        {titleLimit > 0 ? truncate(title, titleLimit) : title}
      </Title>
      {!!text && (
        <Text className={thText} text={textLimit > 0 ? truncate(text, textLimit) : text} />
      )}
      <div className={thBottom}>
        <span className={thLikes}>
          <Icon className={thIcon} name={ICONS.HEART_FILLED} width={thIconSize} />
          {likesCount}
        </span>
        <span className={thAnswers}>
          <Icon className={thIcon} name={ICONS.ANSWERS} width={thIconSize} />
          {answersCount}
        </span>
        {!!seeMoreLabel && <span className={thSeeMore}>{seeMoreLabel}</span>}
      </div>
    </article>
  );
}
